function openSupplierPopup() {
  document.getElementById('supplier-popup').classList.add('is-active');
}

function closeSupplierPopup() {
  document.getElementById('supplier-popup').classList.remove('is-active');
}

document.addEventListener('DOMContentLoaded', function () {

  const form = document.getElementById('supplier-intake-form');
  if (!form) return;

  form.addEventListener('submit', async function (e) {

    e.preventDefault();

    const submitButton = form.querySelector('button[type="submit"]');
    const originalText = submitButton.innerHTML;

    submitButton.disabled = true;

    submitButton.innerHTML = `
      <span class="supplier-loading">
        <span class="spinner"></span>
        Submitting
      </span>
    `;

    try {

      const formData = new FormData(form);

      const response = await fetch(form.action, {
        method: 'POST',
        body: formData
      });

      if (!response.ok) throw new Error('Submission failed');

      form.innerHTML = `
  <div class="supplier-success">
    <p><strong>Supplier registration received.</strong></p>
    <p>We will review your submission for possible matching with cooperative procurement activity.</p>
  </div>
`;

setTimeout(function () {
  closeSupplierPopup();
  form.reset();
}, 4000);

    } catch (error) {

      submitButton.disabled = false;
      submitButton.innerHTML = originalText;

      alert('Submission failed. Please try again.');

    }

  });

});